module.exports = __webpack_public_path__ + "static/img/aws-cci-7.220bc22f.png";